import { faArrowUp, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { SUCCESS_GREEN_COLOR } from '@/constants/color';

import { Props } from './types';

const CompleteChecklistItem = ({ text, link }: Props) => {
  return (
    <div data-testid="complete-checklist-item" className="flex items-center">
      <span className={SUCCESS_GREEN_COLOR}>
        <FontAwesomeIcon icon={faCheckCircle} className="mr-2" data-testid="check-icon" />
      </span>

      <span>{text}</span>

      {link && (
        <a
          href={link}
          target={link.startsWith('#') ? '_self' : '_blank'}
          rel={link.startsWith('#') ? undefined : 'noopener noreferrer'}
          className="ml-2 opacity-60 hover:opacity-100"
          data-testid="external-link">
          <FontAwesomeIcon icon={faArrowUp} className="rotate-45" />
        </a>
      )}
    </div>
  );
};

export default CompleteChecklistItem;
